<div id="simulation-head-wrap" class="theme-{{simulationName}}">
	<div class="common-back-btn" (click)="close($event)"></div>
	<div id="progress-wrap">
    <div id="progressWrap" [ngClass]="progressTheme">
      <div class="progress">
        <div class="progress-inner" [ngStyle]="{'width':progress+'%'}"></div>
      </div>
    </div>
    <div id="progress-txt"><span [innerHTML]="progress"></span>%</div>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-head/case-practice-head.component.html